var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['profile-short', !_vm.url ? 'placeholder' : ''],attrs:{"id":_vm.id,"tabindex":"0"}},[(_vm.url)?_c('img',{attrs:{"src":_vm.url,"alt":"Profile Image"}}):_c('Placeholder',{attrs:{"size":"44px","text":_vm.abbreviation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }